import { ReactNode, useMemo } from 'react'
import { toast as sonnerToast } from 'sonner'
import Toast from '../kit/Toast'

type ToastOptions = {
  description?: string
  action?: {
    label: string
    onClick: () => void
  }
  duration?: number
}

const addSuccessToast = (content: ReactNode, options?: ToastOptions) => {
  return sonnerToast.custom(
    (id) => (
      <Toast
        id={id}
        kind={'success'}
        title={content}
        description={options?.description}
        action={options?.action}
      />
    ),
    { duration: options?.duration }
  )
}

const addInfoToast = (content: ReactNode, options?: ToastOptions) => {
  return sonnerToast.custom(
    (id) => (
      <Toast
        id={id}
        kind={'info'}
        title={content}
        description={options?.description}
        action={options?.action}
      />
    ),
    { duration: options?.duration }
  )
}

// preemptively using useCallback since the hook is used often
const addErrorToast = (content: ReactNode, options?: ToastOptions) => {
  return sonnerToast.custom(
    (id) => (
      <Toast
        id={id}
        kind={'error'}
        title={content}
        description={options?.description}
        action={options?.action}
      />
    ),
    { duration: options?.duration }
  )
}

/**
 * Hook gathering the toasts from sonner
 */
const useToasts = () => {
  return useMemo(
    () => ({
      addErrorToast,
      addInfoToast,
      addSuccessToast
    }),
    []
  )
}

export default useToasts
